import type { GroupRole } from "../model/types";

export const roleLabels: Record<GroupRole, string> = {
    Creator: "Создатель",
    Manager: "Менеджер",
    Member: "Участник",
};
